import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useChatStore } from "@/stores/useChatStore.ts";

export const Route = createFileRoute("/flow-session/$sessionId")({
  component: RouteComponent,
  head: () => ({
    meta: [{ title: "Opening Chat | Eedi Tutor Dashboard" }],
  }),
});

function RouteComponent() {
  const { AddNewChat, SetChatActive, SetChatHasBeenOpened } = useChatStore();
  const { sessionId } = Route.useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const flowGeneratorSessionId = Number(sessionId);
    const linkedMessageId = new URLSearchParams(window.location.search).get("message");

    if (linkedMessageId) {
      sessionStorage.setItem(`linked-message-${flowGeneratorSessionId}`, linkedMessageId);
    }

    AddNewChat({
      flowGeneratorSessionId,
    });
    SetChatHasBeenOpened(flowGeneratorSessionId);
    SetChatActive(Number(sessionId));
    navigate({ to: "/" }).catch((e: Error) => {
      console.error("Could not redirect", e);
      window.location.assign("/");
    });
  }, [AddNewChat, SetChatActive, navigate, sessionId, SetChatHasBeenOpened]);

  return <div>Hello {sessionId}</div>;
}
